/*
 * @Author: your name
 * @Date: 2022-03-28 18:53:15
 * @LastEditTime: 2022-03-28 18:55:05
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /h5-new-media/src/extend/config.wx.js
 */
export default {
  defaultApp: '多保鱼',
  app: {
    多保鱼: {
      name: '多保鱼',
      alias: 'duobaoyu',
      appId: 'wx26349c28545d99a1',
      httpSrc: '/weixin/hexiangServiceAccounts/getSignature'
    },
    保鱼淘保: {
      // 预发
      name: '保鱼淘保',
      alias: 'baoyutaobao',
      appId: 'wx66bbc2d9c3ab57b9',
      httpSrc: '/weixin/hexiangServiceAccounts/getSignature',
      new: true
    },
    凡声比卡丘: {
      // 测试
      name: '凡声比卡丘',
      alias: 'baoyupingxian',
      appId: 'wx06ca34832cda49d1',
      httpSrc: '/weixin/hexiangServiceAccounts/getSignature'
    },
    保鱼鱼指南: {
      // 开发
      name: '保鱼鱼指南',
      alias: 'baoyuzhinan',
      appId: 'wxacd60aef06b506da',
      httpSrc: '/weixin/hexiangServiceAccounts/getSignature'
    },
    我爱多保鱼: {
      name: '我爱多保鱼',
      alias: 'loveduobaoyu',
      appId: 'wx27ea50e1e31fcfab',
      httpSrc: '/weixin/getSignature'
    },
    多保鱼服务号: {
      name: '多保鱼服务',
      alias: 'duobaoyuservice',
      appId: 'wxba34ba61c042a5af',
      httpSrc: '/weixin/serviceAccounts/getSignature'
    },
    多财学堂: {
      name: '多财学堂',
      alias: 'duocai',
      appId: 'wx4d5a87ae1b3e3951',
      httpSrc: '/weixin/hexiangServiceAccounts/getSignature'
    }
  },
  jsApiList: [
    'updateTimelineShareData',
    'updateAppMessageShareData',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'onVoicePlayEnd',
    'uploadVoice',
    'downloadVoice',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
    'translateVoice',
    'getNetworkType',
    'openLocation',
    'getLocation',
    'hideOptionMenu',
    'showOptionMenu',
    'hideMenuItems',
    'showMenuItems',
    'hideAllNonBaseMenuItem',
    'showAllNonBaseMenuItem',
    'closeWindow',
    'scanQRCode',
    'chooseWXPay',
    'openProductSpecificView',
    'addCard',
    'chooseCard',
    'openCard',
    'miniProgram',
    'getLocalImgData'
  ]
};
